/**
 * 请求相关的配置函数
 * @file 请求库工具函数封装
 * @author author-name(lhb 1301465186@qq.com)
 */

import {
  Message,
  Notification
} from '@aiwins/admin-ui'
import router from '@/router/index'
/**
 * message 提示函数
 *
 * @param {*} msg 提示的信息，5秒后关闭
 */
 export const message = msg => {
  Message({
    message: msg,
    type: 'error',
    duration: 5 * 1000,
    showClose: true
  })  
}

/**
 * notification 提示函数 
 *
 * @param {*} msg 提示信息
 * @param {*} a  提示信息的下标
 */
export const notification = (msg,a) => {
  Notification({
    title: '请求异常',
    type: 'error',
    message: msg,
    offset: 70 * a,
    showClose: true
  })
}

/**
 * 登录页跳转函数
 *
 */
export const toLogin = () => {
  router.push({
    path: '/login'
  })
}

/**
 * 请求失败后的错误统一处理
 *
 * @param {*} status 响应的状态码
 * @param {*} msg    响应的信息
 */
export const errorHandle = (status,msg) => {
  switch (status){
    // 400: token获取异常 || 请求参数异常
    // 跳转登录页
    // case 400:
    //     toLogin();
    //     break;
    // // 401: 未登录 || 未经授权
    // // 跳转登录页
    // case 401:
    //     toLogin();
    //     break;
    // 403: token 过期 || 权限不足
    // 展示提示信息
    // case 403:
    //     // message('温馨提示:用户访问权限不足!');
    //     break;
    // 其他错误，直接展示后台错误提示
    default: 
        message(msg);   
  }
}

/**
 * 请求成功后code响应解析处理
 * 
 * @param {*} code 后台返回的code码
 * @param {*} msg  响应的信息
 */
// export const successHandle = (code,msg) => {

// }